import React from "react";
import { Container, Row, Col } from "react-grid-system";

// import Layout from "../components/Layouts/layout"
import PageLayout from "../layouts/MainLayout";
// import SEO from "../components/seo"

const OBDGlossaryPage = () => {
  var glossaryArr = [
    {
      id: "atFaultClaims",
      term: "At Fault Claims",
      definition:
        "Occurs when the builder or vendor has failed to resolve a homeowner claim that is covered under the warranties and Tarion has stepped in to make repairs or provide a cash settlement to resolve the claim with the homeowner. A single home may have more than one claim, and claims on the same home may occur in different years.",
    },
    {
      id: "breach",
      term: "Breach",
      definition:
        "Outstanding claims on cases where there was a warranty breach by the builder or vendor. ",
    },
    {
      id: "breachUncollect",
      term: "Breach Uncollectable",
      definition:
        "Outstanding claims on cases where there was a warranty breach by the builder or vendor.",
    },
    {
      id: "builder",
      term: "Builder",
      definition:
        "A person or company who will build or offer to build a new home. It is the builder who undertakes the performance of the work and supplies the materials to construct a completed home.",
    },
    {
      id: "chargeableConciliations",
      term: "Chargeable Conciliations",
      definition:
        "The number of homes with warranted items that Tarion has determined should have been resolved by the builder. This number could include homes where the warranted items are still under dispute by the builder. More details on chargeability is in <a href='https://www.tarion.com/sites/default/files/2023-03/RB04%20-%20Chargeability%20-%20rvsd%20June%2024%202021.pdf' target='_blank'>Tarion’s Bulletin No. 04.</a>",
    },
    {
      id: "condominium",
      term: "Condominium",
      definition:
        "A type of home that is part of a larger project that includes shared areas, or common elements/and or amenities.",
    },
    {
      id: "condoProps",
      term: "Condo Properties",
      definition:
        "The number of condominium properties that have been enrolled with Tarion and are under warranty.",
    },
    {
      id: "disciplineAct",
      term: "Disciplinary Activities",
      definition:
        "Actions taken by the Discipline and Appeals Committees for violations of the Code of Ethics. This could include requiring a licensee to take educational courses, imposing fines up to a maximum of $50,000 for individual licensees and $100,000 for non-individual licensees.",
    },
    {
      id: "doingBusinessName",
      term: "Doing Business As Name",
      definition:
        "The name under which a business operates and presents itself to the public. This may differ from the Legal name, which is the registered name of a company that appears on legal documents.",
    },
    {
      id: "enrolmentDate",
      term: "Enrolment Date",
      definition:
        "The date that the home was enrolled in the warranty program with Tarion.",
    },
    {
      id: "freehold",
      term: "Freehold",
      definition:
        "A home on which the purchaser agrees to buy both a parcel of land and a residential dwelling unit on that land or a contract to build a new home on land already owned by the purchase",
    },
    {
      id: "freeholdProps",
      term: "Freehold Properties",
      definition:
        "The number of freehold properties that have been enrolled with Tarion and are under warranty.",
    },
    {
      id: "illegalBuildingConvictions",
      term: "Illegal Building/Selling Convictions",
      definition: `Anyone who plans to build and/or sell a new home in Ontario must be licensed by the Home Construction Regulatory Authority (HCRA). Upon licensing, builders and sellers must apply to Tarion for applicable approvals (such as the Qualification for Enrolment Process) and also enrol the home in the warranty plan. Failure to complete any of the mentioned is illegal.`,
    },
    {
      id: "legalName",
      term: "Legal Name",
      definition:
        "The registered name of a company that appears in legal documents. This may differ from the “Doing Business As” name.",
    },
    {
      id: "lat",
      term: "Licence Appeal Tribunal",
      definition:
        "An independent tribunal created by the Ontario government to provide licensees with an impartial appeal process.",
    },
    {
      id: "lot",
      term: "Lot #",
      definition:
        "A reference number assigned by the municipality to a piece of land. A home’s lot number can be found in the legal description of the home. Lot numbers may differ from the final home address. Lot # may differ from the final address #.",
    },
    {
      id: "majorStructuralDefect",
      term: "Major Structural Defect",
      definition:
        "Any defect in work or materials that results in the failure of a load-bearing part of the home's structure or materially and adversely affects its load-bearing function; or any defect in work or materials that materially and adversely affects the use of the building as a home.",
    },
    {
      id: "newHome",
      term: "New Home",
      definition:
        "A self-contained, single-family dwelling that has not been previously occupied and is capable of year-round occupation with eating, sleeping, heating, bathroom facilities.",
    },
    {
      id: "noticeOfProposal",
      term: "Notice of Proposal",
      definition:
        "A document issued by the HCRA which notifies an applicant or licensee in writing of its intent to: refuse to grant or renew a licence; suspend; or revoke a licence; or apply conditions to a licence.",
    },
    {
      id: "ordersIssued",
      term: "Notices/Orders Issued",
      definition:
        "A directive requiring a builder or seller to take or refrain from certain actions. Orders may come from the HCRA, Licence Appeal Tribunal or Superior Court and may relate to false advertising, freezing assets or trust funds, or compliance with legislation.",
    },
    {
      id: "outstandingClaimsPaidOwing",
      term: "Outstanding Claims Paid Owing",
      definition:
        "The amount owing by the builder or vendor to Tarion as a result of warranty claim(s) submitted by a homeowner and investigated and/or resolved by Tarion that has been outstanding for greater than 30 days. This number includes Tarion Action on Behalf Uncollectable plus Breach Uncollectable. ",
    },
    {
      id: "ownerBuilder",
      term: "Owner-Builder",
      definition:
        "An individual who is building or managing the building of a new home for their own personal use/residence on land they own. An Owner-Builder is not required to obtain a licence from the HCRA. This is distinctly different from a contract home whereby the homeowner hires a builder to build the home, in which the builder would need to be licensed by the HCRA. An Owner-Builder built home does not have statutory warranty coverage and is not eligible for warranty coverage under the Ontario New Home Warranties Plan Act.",
    },
    {
      id: "plan",
      term: "Plan #",
      definition:
        "A reference number assigned to each home by the municipality in which the home is located.",
    },
    {
      id: "registrarNoticesIssued",
      term: "Notices Issued",
      definition:
        "Under the New Home Construction Licensing Act, 2017, the HCRA may issue a Notice of Proposal to an applicant or licensee with the intent to refuse to grant or renew a licence, suspend or revoke a licence or apply conditions to a licence to which the licensee has or has not provided their consent. This metric signals the number of Notice of Proposals that have been issued and been sustained after appeal (if an appeal was made). ",
    },
    {
      id: "officerDirector",
      term: "Principal/Officer/Director",
      definition:
        "Directors and Officers are named in the corporation’s filings.",
    },
    {
      id: "owner",
      term: "Owner",
      definition:
        "A person who first acquires a home from its vendor for occupancy, and the person’s successors on title of the home.",
    },
    {
      id: "renewalDueDate",
      term: "Renewal due date",
      definition:
        "The date that is 30 days before the expiry date of a licence. If a renewal application is submitted after the renewal due date, a late fee will be applied to the renewal application. All licences must be renewed by their renewal due date.",
    },
    {
      id: "statusUpdated",
      term: "Status Last Updated",
      definition:
        "The date when a builder or seller's licence was last updated.",
    },
    {
      id: "tab",
      term: "Tarion Action on Behalf (TAB) of Vendor/Builder",
      definition:
        "Outstanding amount owing for claim case(s) where Tarion is fulfilling the warranty obligation on behalf of the builder or vendor. This may also include amounts owing as a result of chargeable conciliation fees charged to the builder or vendor. ",
    },
    {
      id: "tabUncollectable",
      term: "Tarion Action on Behalf (TAB) Uncollectable",
      definition:
        "Outstanding amount owing for claim case(s) where Tarion is fulfilling the warranty obligation on behalf of the builder or vendor. This may also include amounts owing as a result of chargeable conciliation fees charged to the builder or vendor. ",
    },
    {
      id: "totalDollars",
      term: "Total Dollars Paid in Claims",
      definition:
        "Shows the total amount of money a vendor/builder has paid in claims of warranty violations. ",
    },
    {
      id: "totalPossessions",
      term: "Total Possessions",
      definition:
        "The total number of freehold or condominium properties delivered by the licensee to homeowners.",
    },
    {
      id: "umbrella",
      term: "Related Companies",
      definition:
        "A group of builders or vendors sharing at least one common officer, director, principal, partner, or franchise. The related group of companies is not a legal entity and does not have its own licence number, but each member company of the related company is a separate legal entity with its own licence number.",
    },
    {
      id: "vendor",
      term: "Vendor (seller)",
      definition:
        "A person/company who offers to sell or sells a new, not previously occupied, home.",
    },
    {
      id: "warranty",
      term: "Warranty",
      definition:
        "By law, new homes built in Ontario are provided with a warranty by the builder. It is the role of Tarion to ensure that buyers of newly built homes in Ontario receive the coverage they are entitled to under their builder’s warranty.",
    },
    {
      id: "warrantyStart",
      term: "Warranty Start",
      definition: "The date on which warranty coverage for a home will begin.",
    },
    {
      id: "warrantyEnd",
      term: "Warranty End",
      definition: "The date in which warranty coverage for the property ends.",
    },
  ];

  const statusArr = [
    {
      id: "cnc",
      term: "Cancelled",
      definition:
        "A builder or seller that is no longer licensed by the HCRA because it voluntarily surrendered its licence. A cancelled vendor/builder cannot legally build or sell new homes. ",
    },
    {
      id: "chg",
      term: "Charged",
      definition:
        "When a builder, seller or individuals associated with the company has been charged with an offence under the New Home Construction Licensing Act, 2017 or the Ontario New Home Warranties Plan Act.",
    },
    {
      id: "cnv",
      term: "Convicted",
      definition:
        "When a builder or seller has been charged and convicted in the Ontario Court of Justice for a violation under the New Home Construction Licensing Act, 2017 or the Ontario New Home Warranties Plan Act..",
    },
    {
      id: "exp",
      term: "Expired",
      definition:
        "When a builder or seller is no longer licensed by the HCRA because it did not renew its licence. An expired vendor/builder cannot legally build or sell new homes.",
    },
    {
      id: "conAppeal",
      term: "Licence Conditions Under Appeal",
      definition:
        "The HCRA Registrar's proposal to apply conditions on a licence is under appeal by the applicant or licensee to the Licence Appeal Tribunal.",
    },
    {
      id: "licenced",
      term: "Licensed",
      definition:
        "The builder or seller that is currently licensed by the HCRA to build or sell new homes in Ontario.",
    },
    {
      id: "licencedCon",
      term: "Licensed with Conditions",
      definition:
        "The builder or seller is currently licensed by the HCRA to build and/or sell new homes, subject to conditions or restrictions. Failing to abide by the conditions of a licence will result in additional regulatory action.",
    },
    // {
    //   id: "nopCon",
    //   term: "Notice of Conditions Issued",
    //   definition:
    //     "The HCRA Registrar has proposed to apply conditions on a licence.",
    // },
    // {
    //   id: "nopRefuse",
    //   term: "Notice of Refusal Issued",
    //   definition:
    //     "The HCRA Registrar has proposed to refuse to renew a licence.",
    // },
    // {
    //   id: "nopRevoke",
    //   term: "Notice to Revoke Issued",
    //   definition: "The HCRA Registrar has proposed to revoke a licence.",
    // },
    // {
    //   id: "nopSuspend",
    //   term: "Notice to Suspend Issued",
    //   definition: "The HCRA Registrar has proposed to suspend a licence.",
    // },
    {
      id: "refuseApp",
      term: "Refusal Under Appeal",
      definition:
        "The HCRA's Notice of Proposal to refuse to renew or grant a licence is under appeal with the Licence Appeal Tribunal. The licensee's most recent licence status is applicable until the appeal is resolved.",
    },
    {
      id: "refused",
      term: "Refused",
      definition:
        "The most recent application for a licence has been rejected.",
    },
    {
      id: "revApp",
      term: "Revocation Under Appeal",
      definition:
        "The HCRA Registrar’s proposal to revoke the licence is under appeal at the Licensing Appeal Tribunal. The licence remains valid until the appeal is resolved.",
    },
    {
      id: "revoked",
      term: "Revoked",
      definition:
        "The licence has been terminated because the builder or vendor no longer meets licensing requirements. The builder or vendor is prohibited from building or selling new homes.",
    },
    {
      id: "suspend",
      term: "Suspended",
      definition:
        "The builder or seller is prohibited from building or selling new homes.",
    },
    {
      id: "suspendApp",
      term: "Suspension Under Appeal",
      definition:
        "The HCRA’s Notice of Proposal to suspend a licence is under appeal at the Licensing Appeal Tribunal. The licence remains valid until the appeal is resolved.",
    },
    {
      id: "unlicensed",
      term: "Unlicensed",
      definition:
        "A person or entity who is not currently licensed under the New Homes Construction Licensing Act, 2017.",
    },
    {
      id: "withdraw",
      term: "Withdrawn",
      definition:
        "The licensee has voluntarily withdrawn their application for a licence.",
    },
  ];

  return (
    <PageLayout
      pageHeader={
        <>
          <span className="bold">Glossary</span> of Terms
        </>
      }
    >
      <Container>
        <Row>
          <Col md={12}>
            <p>As Ontario’s home builder regulator, the HCRA provides access to a searchable database with information about Ontario’s approximately 7,000 licensed home builders and sellers. Some of the information that the directory provides includes whether a builder is licensed (which is required by law), has had any convictions, the number of homes they have built, and their warranty history. We recommend that you start your research with the Ontario Builder Directory - the official source of information about builders and sellers in Ontario.</p>
          </Col>
          <Col md={12} style={{ marginTop: `2rem` }}>
            <ul className="sitemapList">
              {glossaryArr.map((link, i) => (
                <li id={link.id} key={link.id} className="definition">
                  <span>{link.term}</span>
                  <span dangerouslySetInnerHTML={{ __html: link.definition }}></span>
                </li>
              ))}
            </ul>
          </Col>

          <Col md={12} style={{ marginTop: `2rem` }}>
            <h2 id="licenceStatus">Licence Status</h2>
            <ul className="sitemapList">
              {statusArr.map((link, i) => (
                <li id={link.id} key={link.id} className="definition">
                  <span>{link.term}</span>
                  <span dangerouslySetInnerHTML={{ __html: link.definition }}></span>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </PageLayout>
  );
};
export default OBDGlossaryPage;
